export default __webpack_public_path__ + "static/brilliantly-warm-banner-3-b-6f2c7fa8b7826b81ecf9b0f5df288041.webp";